import { QueryKey } from '@/configs/queryKeys';
import { AttributeValue } from './AttributeValueApi';
import { Attachment, UUID } from '@/types/types';
import { CreatorAccessory, SerializedCreator } from '@/types/creator';
import ProductTypeVariationApi, {
	ProductTypeVariation,
	ProductTypeVariationAccessory,
} from './ProductTypeVariationApi';
import { Accessory } from './AccessoryApi';
import EntityApi, { BaseEntity } from './EntityApi';

export interface ProductyAccessory {
	id: UUID;
	refId: UUID;
	posY: number;
	variationAccessory?: ProductTypeVariationAccessory;
	variationAccessoryId: UUID;
	customFieldAnswers: Record<string, string>;
	attributeValues?: AttributeValue[];
	attributeValuesIds: UUID[];
	mountingSide: CreatorAccessory['mountingSide'];
}

export interface Product extends BaseEntity {
	name: string;
	image?: Attachment;
	productTypeVariation?: ProductTypeVariation;
	productTypeVariationId: UUID;
	customValues: Record<UUID, string>;
	attributeValues?: AttributeValue[];
	attributeValuesIds: UUID[];
	productAccessories: ProductyAccessory[];
	serializedCreator: SerializedCreator;
}

class ProductApi extends EntityApi<Product> {
	constructor() {
		super(QueryKey.products);
		this.loadWithProductTypeVariation =
			this.loadWithProductTypeVariation.bind(this);
	}

	async loadWithProductTypeVariation({
		id,
		allAccessories,
	}: {
		id: UUID;
		allAccessories: Accessory[];
	}) {
		const product = await super.mutationGetOne(id);

		if (!product.productTypeVariationId)
			throw new Error('MISSING_PRODUCT_TYPE_VARIATION');

		product.productTypeVariation =
			await ProductTypeVariationApi.loadWithRelations({
				id: product.productTypeVariationId,
				allAccessories,
			});

		return product;
	}
}

export default new ProductApi();
